import {Assert} from "common/Assert";

export function SequenceData() {

    let data = {
        urls: {
            'start': "",
            'resume': ""
        },
        sMode: null,
        bIsResultRelevant: false,
        nScore: 0,
        nMasteryScore: 80,
    };

    function extendData( otherData ) {
        Object.assign( data, otherData );
    }

    function getData() {
        return data;
    }

    function setStartUrl(sUrl, sUsecase) {

        Assert.checkArgument( sUrl );

        if (sUsecase && (sUsecase.length > 0)) {
            data.urls[sUsecase] = sUrl;
            return;
        }

        data.urls['start'] = sUrl;
    }

    function getStartUrl(sUsecase) {

        if (sUsecase && (sUsecase.length > 0) && (typeof(data.urls[sUsecase] !== "undefined"))) {
            return ( data.urls[sUsecase] );
        }

        return ( data.urls['start'] );
    }

    function setMode(sMode) {
        data.sMode = sMode;
    }

    function getMode() {
        return ( data.sMode );
    }

    function setScore( sScore ) {
        data.nScore = Number(sScore);
        if (isNaN(data.nScore)) {
            data.nScore = 0;
        }
    }

    function getScore() {
        return data.nScore;
    }

    function setMasteryScore(nMasteryScore) {
        data.nMasteryScore = Number(nMasteryScore);
        if (isNaN(data.nMasteryScore)) {
            data.nMasteryScore = 80;
        }
    }

    function getMasteryScore() {
        return data.nMasteryScore;
    }

    function isPassed() {
        return ( data.nScore >= data.nMasteryScore );
    }

    function setResultRelevant(bSwitch) {
        data.bIsResultRelevant = bSwitch;
    }

    function isResultRelevant() {
        return ( data.bIsResultRelevant );
    }

    function isExecutable() {
        // only sequences with start url
        return ( (data.urls['start'] !== null) && (data.urls['start'].length > 0) );
    }

    function isELearning() {
        return ( (getMode() === "learning") && isExecutable() );
    }

    function isAssessment() {
        return (getMode() === "assessment") && isExecutable();
    }

    // revealing public api
    return {
        data : data, // deprecated since 19.0! Use getData() instead!

        extendData : extendData,
        getData : getData,

        setStartUrl : setStartUrl,
        getStartUrl : getStartUrl,

        setMode : setMode,
        getMode : getMode,

        setScore : setScore,
        getScore : getScore,

        setMasteryScore : setMasteryScore,
        getMasteryScore : getMasteryScore,

        isPassed : isPassed,

        setResultRelevant : setResultRelevant,
        isResultRelevant : isResultRelevant,

        isExecutable : isExecutable,

        isELearning : isELearning,
        isAssessment : isAssessment
    };
}
